import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { BookingService } from 'src/app/services/booking.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { EventType } from 'src/enum/eventtype';
import { RoleType } from 'src/enum/roletype';

@Component({
  selector: 'app-adminsendbackbooking',
  templateUrl: './adminsendbackbooking.component.html',
  styleUrls: ['./adminsendbackbooking.component.scss']
})
export class AdminsendbackbookingComponent implements OnInit {
  showNotes: boolean = true;
  form: FormGroup;
  sentbackform:FormGroup;
  id: any;
  public eventEnum = EventType;
  public roleEnum=RoleType
  isDisabled: boolean = false;
  loading:boolean = true;
  sendBackDisabled: boolean = false;
  roleid: number;
  upload_filename: any;
  fileuplode = [];
  fileType: number;
  ftFileName: any;
  filesResult: any;

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private router: Router,
    public dialogRef: MatDialogRef<AdminsendbackbookingComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    private bookingService: BookingService,
    public addServiceDialog: MatDialog,
    private userSessionService:UserSessionService
  ) {
    this.id = this.dataRecievedData
    this.roleid=this.userSessionService.roleId()
  }


  ngOnInit(): void {
    this.showNotes = true;
    this.initializeValidators();
  }


  initializeValidators() {
    this.form = this.formBuilder.group({
      remarks: [null, Validators.required]
    })
    this.sentbackform = this.formBuilder.group({
      sendbackremarks: [null, Validators.required],
      upload: [null, Validators.required],
      upload_filename: [null]
    })
  }


  next(isProceed) {
    this.dialogRef.close(isProceed);

  }
  sendbackcancel(isProceed) {
    this.dialogRef.close(isProceed);

  }
 
  validateFormControl() {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  goToAction() {
    this.isDisabled = true;
    this.loading = true;
    if (this.form.valid) {
      let request = {
        id: this.id.sessionId,
        eventType: this.eventEnum.EEApproval ,
        approvedStatusType: 1,
        remarks: this.form.value.remarks,
      };
      this.bookingService
        .approvalmanufacturerapproval(request)
        .subscribe((res) => {
          if (res && res.isSuccess) {
            this.isDisabled = false;
            this.loading = false;
            this.alertService.success('Successfully Approved the farmer Subsidy');
            this.dialogRef.close();
            this.router.navigate(['/eefarmerbookingapproval'])
            
          }
          else {
            this.isDisabled = false;
            this.loading = false;
            this.alertService.error(res.htmlFormattedFailures);
          }
      
        });
    } else {
      this.isDisabled = false;
      this.loading = false;
      this.validateFormControl()
    }
  }

  validateFormControlsremarks() {
    Object.keys(this.sentbackform.controls).forEach((field) => {
      const control = this.sentbackform.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  sendbackremarks(){
    this.sendBackDisabled = true;
    this.loading = true;
    if(this.id.eventType != EventType.PaymentInfo){
      this.sentbackform.controls["upload"].clearValidators();
      this.sentbackform.controls["upload"].updateValueAndValidity();
    }
    if (this.sentbackform.valid) {
      let request = {
        id: this.id.sessionId,
        eventType:this.id.id == EventType.DealerAuthenticate ? EventType.Admindealersendback :
            this.id.id == EventType.PaymentInfo ? EventType.AdminBookingCancelled :
            (this.id.id == EventType.AEApproval && this.id.status == 1) ? EventType.AdminAEPhysicalVerifiedSendback :
            (this.id.id == EventType.AEApproval && this.id.status == 2) ? EventType.AdminBookingCancelled :'',
        remarks: this.sentbackform.value.sendbackremarks,
        attachment:this.fileuplode
      };
      this.bookingService
        .sendBack(request)
        .subscribe((res) => {
          if (res) {
            this.sendBackDisabled = false;
            this.loading = false;
            this.alertService.success(this.roleid==this.roleEnum.AssistantExecutiveEngineer?'AEE Send Back Successfully':this.roleid==this.roleEnum.HortiJDHorDDH?'JDH Send Back Successfully':this.roleid==this.roleEnum.AgriJDA?'ADH Send Back Successfully':this.roleid==this.roleEnum.DBTAdmin && this.id.id == EventType.PaymentInfo ?'Farmer booking canceled successfully':(this.roleid === this.roleEnum.DBTAdmin && this.id.id !== EventType.PaymentInfo)
            ? (this.id.status == 1 
                ? 'Admin Send Back Successfully' 
                : 'Farmer booking canceled successfully')
            : 'Saved Successfully');
            this.dialogRef.close();
            this.router.navigate(['/aefarmerbooking'])
          }
          else {
            this.sendBackDisabled = false;
            this.loading = false;
            // this.alertService.error(res.htmlFormattedFailures);
          }
        });
    } else {
      this.sendBackDisabled = false;
      this.loading = false;
      this.validateFormControlsremarks()
    }
  }

  uploadSelected(event: any) {
    this.fileuplode = [];
    const file = event.target.files[0];
    this.checkFile(file).then(result => {
      if (!result) {
        if (
          file.type === 'application/pdf'
           || file.type === 'image/png' ||
          file.type === 'image/jpg' ||
          file.type === 'image/jpeg'
        ) {
          let filesize = file.size;
          let acceptsize = parseInt((filesize / 1024).toFixed(2));
          if (acceptsize <= 2048) {
            let name = file.name;


            let checkType = file.type;
            let getFileType = checkType.split('/');
            if (getFileType[1] == 'pdf') {
              this.fileType = 2;
            } else {
              this.fileType = 1;
            }
            if (file) {
              const reader = new FileReader();
              reader.readAsDataURL(event.target.files[0]);
              reader.onload = (event: any) => {
                this.ftFileName = event.target.result;
                this.filesResult = event.target.result.split(',')[1];
                this.sentbackform.controls['upload'].setValue(this.filesResult);
                this.sentbackform.controls['upload_filename'].setValue(file.name);
                this.upload_filename = file.name;
                this.fileuplode.push({
                  id: this.fileuplode.length + 1 - 1,
                  attachmentFilename: file.name,
                  attachmentType: 78,
                  fileType: this.fileType,
                  base64String: this.filesResult
                });
              };
            }
          } else {
            this.alertService.error(
              'File size is large, Please upload less than 2 MB'
            );
          }
        } else {
          this.alertService.error('Please upload PDF only');
        }
      } else {
        this.alertService.error('Please upload valid file');
      }
    });
  }

  async checkFile(file: File): Promise<boolean> {
    const contents = await this.readFile(file);
    return contents.includes('error');
  }

  readFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const contents = reader.result as string;
        resolve(contents);
      };
      reader.onerror = () => {
        reject(reader.error);
      };
      reader.readAsText(file);
    });
  }

}
